<template>
  <section>
    <el-row class="warp">
      <el-col :span="6" class="warp-breadcrum">
          <el-breadcrumb separator="/">
          <!--
            <el-breadcrumb-item :to="{ path: '/' }">
              <b>首页</b>
            </el-breadcrumb-item>
            -->
            <el-breadcrumb-item>加工任务列表</el-breadcrumb-item>
          </el-breadcrumb>
      </el-col>
    </el-row>  

    <el-row class="warp">
      <!--工具条 begin-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="DOI：">
            <el-input v-model="searchForm.doi" placeholder="DOI"></el-input>
          </el-form-item>
          <el-form-item label="稿号：">
            <el-input v-model="searchForm.fileName" placeholder="稿号"></el-input>
          </el-form-item>
          <el-form-item label="类型：" prop="dataType">
              <el-select v-model="searchForm.dataType" filterable clearable placeholder="数据类型">
                  <el-option
                  v-for="item in dataTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="期刊：" prop="journalName">
              <el-select v-model="searchForm.issn" filterable clearable placeholder="期刊" @visible-change="getJournalList">
                  <el-option
                  v-for="item in journals"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
              <el-select v-model="searchForm.status" filterable clearable placeholder="任务状态">
                  <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
              <el-button size="mini" type="primary" @click="findResult(null)">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col> 
      <!--工具条 end-->

      <!-- 列表显示 begin-->
      <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" >
          <!-------------------------------------------------------->
          <el-tab-pane label="单篇任务" name="individualTask">
              <IndividualTaskList v-bind:searchForm="searchForm" v-if="activeName == 'individualTask'" ref="individualTask"></IndividualTaskList>
          </el-tab-pane>
          <!-------------------------------------------------------->
          <el-tab-pane label="整期任务" name="issueTask">
              <IssueTaskList v-bind:searchForm="searchForm" v-if="activeName == 'issueTask'" ref="issueTask"></IssueTaskList>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <!-- 列表显示 end-->
    </el-row>
  </section>
</template>

<script>
import IndividualTaskList from "./IndividualTaskList.vue";
import IssueTaskList from "./issueTaskList.vue";
import API_JOURNAL from "../../../api/api_journal";

export default {
  components: {
      IndividualTaskList,
      IssueTaskList,
  },
  data() {
    return {
      searchForm:{
        doi:"",
        fileName:"",
        dataType:"",
        issn:"",
        status:"",
      },
      dataTypeList:[],
      journals:[],
      statusList:[
        {
          value: "1",
          label: '待加工文件'
        },
        {
          value: "2",
          label: '加工文件上传失败'
        },
        {
          value: "3",
          label: '加工文件已下载'
        },
        {
          value: "4",
          label: 'SciEngine上传成功'
        },
        {
          value: "5",
          label: 'SciEngine上传失败'
        }
      ],
      
      activeName: 'individualTask',
      //在此添加新的数据定义
      dataTypeOptions: [
        {
          value: 'normal',
          label: '正式出版'
        }, 
        {
          value: 'online_first',
          label: '优先出版'
        }
      ],
    };
  },
  mounted() {
    this.onQuery();
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      var that = this;
      setTimeout(function(){
          that.onQuery();
      },500);
    },

    findJournalList(){
        let that = this;
        API_JOURNAL.getJournalListTree()
        .then(res=>{
            if(res && res.journal){
            that.journals = Object.values(res.journal);
            console.log(
                "......findJournalList:" + JSON.stringify(that.journals)
                );
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求出现异常",
            duration:2000
            });
        });
    },

    findResult(){
      this.onQuery();
    },

    onQuery() {
      //this.findJournalList();
      this.$refs[this.activeName].refresh();
      
    },

    getJournalList(){
      this.journals = this.$refs[this.activeName].getJournals();
    }
  },
  
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Data/ProcessDataManage.vue